export enum LanguageEnum {
  Afar = 1,
  Abkhaz = 2,
  Avestan = 3,
  Afrikaans = 4,
  Akan = 5,
  Amharic = 6,
  Aragonese = 7,
  Arabic = 8,
  Assamese = 9,
  Avaric = 10,
  Aymara = 11,
  Azerbaijani = 12,
  SouthAzerbaijani = 13,
  Bashkir = 14,
  Belarusian = 15,
  Bulgarian = 16,
  Bihari = 17,
  Bislama = 18,
  Bambara = 19,
  BengaliBangla = 20,
  TibetanStandard = 21,
  Breton = 22,
  Bosnian = 23,
  CatalanValencian = 24,
  Chechen = 25,
  Chamorro = 26,
  Corsican = 27,
  Cree = 28,
  Czech = 29,
  OldChurchSlavonic = 30,
  Chuvash = 31,
  Welsh = 32,
  Danish = 33,
  German = 34,
  DivehiDhivehiMaldivian = 35,
  Dzongkha = 36,
  Ewe = 37,
  Greek = 38,
  English = 39,
  Esperanto = 40,
  SpanishCastilian = 41,
  Estonian = 42,
  Basque = 43,
  PersianFarsi = 44,
  FulaFulahPulaarPular = 45,
  Finnish = 46,
  Fijian = 47,
  Faroese = 48,
  French = 49,
  WesternFrisian = 50,
  Irish = 51,
  ScottishGaelicGaelic = 52,
  Galician = 53,
  Guaraní = 54,
  Gujarati = 55,
  Manx = 56,
  Hausa = 57,
  Hebrewmodern = 58,
  Hindi = 59,
  HiriMotu = 60,
  Croatian = 61,
  HaitianHaitianCreole = 62,
  Hungarian = 63,
  Armenian = 64,
  Herero = 65,
  Interlingua = 66,
  Indonesian = 67,
  Interlingue = 68,
  Igbo = 69,
  Nuosu = 70,
  Inupiaq = 71,
  Ido = 72,
  Icelandic = 73,
  Italian = 74,
  Inuktitut = 75,
  Japanese = 76,
  Javanese = 77,
  Georgian = 78,
  Kongo = 79,
  Kikuyu = 80,
  Kwanyama = 81,
  Kazakh = 82,
  Kalaallisut = 83,
  Khmer = 84,
  Kannada = 85,
  Korean = 86,
  Kanuri = 87,
  Kashmiri = 88,
  Kurdish = 89,
  Komi = 90,
  Cornish = 91,
  Kyrgyz = 92,
  Latin = 93,
  Luxembourgish = 94,
  Ganda = 95,
  Limburgish = 96,
  Lingala = 97,
  Lao = 98,
  Lithuanian = 99,
  LubaKatanga = 100,
  Latvian = 101,
  Malagasy = 102,
  Marshallese = 103,
  Māori = 104,
  Macedonian = 105,
  Malayalam = 106,
  Mongolian = 107,
  MarathiMarāṭhī = 108,
  Malay = 109,
  Maltese = 110,
  Burmese = 111,
  Nauru = 112,
  NorwegianBokmål = 113,
  NorthNdebele = 114,
  Nepali = 115,
  Ndonga = 116,
  Dutch = 117,
  NorwegianNynorsk = 118,
  Norwegian = 119,
  SouthNdebele = 120,
  Navajo = 121,
  ChichewaChewaNyanja = 122,
  Occitan = 123,
  Ojibwe = 124,
  Oromo = 125,
  Oriya = 126,
  Ossetian = 127,
  Panjabi = 128,
  Pāli = 129,
  Polish = 130,
  Pashto = 131,
  Portuguese = 132,
  Quechua = 133,
  Romansh = 134,
  Kirundi = 135,
  Romanian = 136,
  Russian = 137,
  Kinyarwanda = 138,
  SanskritSaṁskṛta = 139,
  Sardinian = 140,
  Sindhi = 141,
  NorthernSami = 142,
  Sango = 143,
  Sinhala = 144,
  Slovak = 145,
  Slovene = 146,
  Samoan = 147,
  Shona = 148,
  Somali = 149,
  Albanian = 150,
  Serbian = 151,
  Swati = 152,
  SouthernSotho = 153,
  Sundanese = 154,
  Swedish = 155,
  Swahili = 156,
  Tamil = 157,
  Telugu = 158,
  Tajik = 159,
  Thai = 160,
  Tigrinya = 161,
  Turkmen = 162,
  Tagalog = 163,
  Tswana = 164,
  TongaTongaIslands = 165,
  Turkish = 166,
  Tsonga = 167,
  Tatar = 168,
  Twi = 169,
  Tahitian = 170,
  Uyghur = 171,
  Ukrainian = 172,
  Urdu = 173,
  Uzbek = 174,
  Venda = 175,
  Vietnamese = 176,
  Volapük = 177,
  Walloon = 178,
  Wolof = 179,
  Xhosa = 180,
  Yiddish = 181,
  Yoruba = 182,
  Zhuang = 183,
  Chinese = 184,
  Zulu = 185
}

export const LanguageOptions = [
{ id: 1, label: 'Afar' },
{ id: 2, label: 'Abkhaz' },
{ id: 3, label: 'Avestan' },
{ id: 4, label: 'Afrikaans' },
{ id: 5, label: 'Akan' },
{ id: 6, label: 'Amharic' },
{ id: 7, label: 'Aragonese' },
{ id: 8, label: 'Arabic' },
{ id: 9, label: 'Assamese' },
{ id: 10, label: 'Avaric' },
{ id: 11, label: 'Aymara' },
{ id: 12, label: 'Azerbaijani' },
{ id: 13, label: 'South Azerbaijani' },
{ id: 14, label: 'Bashkir' },
{ id: 15, label: 'Belarusian' },
{ id: 16, label: 'Bulgarian' },
{ id: 17, label: 'Bihari' },
{ id: 18, label: 'Bislama' },
{ id: 19, label: 'Bambara' },
{ id: 20, label: 'Bengali; Bangla' },
{ id: 21, label: 'Tibetan Standard' },
{ id: 22, label: 'Breton' },
{ id: 23, label: 'Bosnian' },
{ id: 24, label: 'Catalan; Valencian' },
{ id: 25, label: 'Chechen' },
{ id: 26, label: 'Chamorro' },
{ id: 27, label: 'Corsican' },
{ id: 28, label: 'Cree' },
{ id: 29, label: 'Czech' },
{ id: 30, label: 'Old Church Slavonic' },
{ id: 31, label: 'Chuvash' },
{ id: 32, label: 'Welsh' },
{ id: 33, label: 'Danish' },
{ id: 34, label: 'German' },
{ id: 35, label: 'Divehi; Dhivehi; Maldivian;' },
{ id: 36, label: 'Dzongkha' },
{ id: 37, label: 'Ewe' },
{ id: 38, label: 'Greek' },
{ id: 39, label: 'English' },
{ id: 40, label: 'Esperanto' },
{ id: 41, label: 'Spanish; Castilian' },
{ id: 42, label: 'Estonian' },
{ id: 43, label: 'Basque' },
{ id: 44, label: 'Persian (Farsi)' },
{ id: 45, label: 'Fula; Fulah; Pulaar; Pular' },
{ id: 46, label: 'Finnish' },
{ id: 47, label: 'Fijian' },
{ id: 48, label: 'Faroese' },
{ id: 49, label: 'French' },
{ id: 50, label: 'Western Frisian' },
{ id: 51, label: 'Irish' },
{ id: 52, label: 'Scottish Gaelic; Gaelic' },
{ id: 53, label: 'Galician' },
{ id: 54, label: 'Guaraní' },
{ id: 55, label: 'Gujarati' },
{ id: 56, label: 'Manx' },
{ id: 57, label: 'Hausa' },
{ id: 58, label: 'Hebrew (modern)' },
{ id: 59, label: 'Hindi' },
{ id: 60, label: 'Hiri Motu' },
{ id: 61, label: 'Croatian' },
{ id: 62, label: 'Haitian; Haitian Creole' },
{ id: 63, label: 'Hungarian' },
{ id: 64, label: 'Armenian' },
{ id: 65, label: 'Herero' },
{ id: 66, label: 'Interlingua' },
{ id: 67, label: 'Indonesian' },
{ id: 68, label: 'Interlingue' },
{ id: 69, label: 'Igbo' },
{ id: 70, label: 'Nuosu' },
{ id: 71, label: 'Inupiaq' },
{ id: 72, label: 'Ido' },
{ id: 73, label: 'Icelandic' },
{ id: 74, label: 'Italian' },
{ id: 75, label: 'Inuktitut' },
{ id: 76, label: 'Japanese' },
{ id: 77, label: 'Javanese' },
{ id: 78, label: 'Georgian' },
{ id: 79, label: 'Kongo' },
{ id: 80, label: 'Kikuyu' },
{ id: 81, label: 'Kwanyama' },
{ id: 82, label: 'Kazakh' },
{ id: 83, label: 'Kalaallisut' },
{ id: 84, label: 'Khmer' },
{ id: 85, label: 'Kannada' },
{ id: 86, label: 'Korean' },
{ id: 87, label: 'Kanuri' },
{ id: 88, label: 'Kashmiri' },
{ id: 89, label: 'Kurdish' },
{ id: 90, label: 'Komi' },
{ id: 91, label: 'Cornish' },
{ id: 92, label: 'Kyrgyz' },
{ id: 93, label: 'Latin' },
{ id: 94, label: 'Luxembourgish' },
{ id: 95, label: 'Ganda' },
{ id: 96, label: 'Limburgish' },
{ id: 97, label: 'Lingala' },
{ id: 98, label: 'Lao' },
{ id: 99, label: 'Lithuanian' },
{ id: 100, label: 'Luba-Katanga' },
{ id: 101, label: 'Latvian' },
{ id: 102, label: 'Malagasy' },
{ id: 103, label: 'Marshallese' },
{ id: 104, label: 'Māori' },
{ id: 105, label: 'Macedonian' },
{ id: 106, label: 'Malayalam' },
{ id: 107, label: 'Mongolian' },
{ id: 108, label: 'Marathi (Marāṭhī)' },
{ id: 109, label: 'Malay' },
{ id: 110, label: 'Maltese' },
{ id: 111, label: 'Burmese' },
{ id: 112, label: 'Nauru' },
{ id: 113, label: 'Norwegian Bokmål' },
{ id: 114, label: 'North Ndebele' },
{ id: 115, label: 'Nepali' },
{ id: 116, label: 'Ndonga' },
{ id: 117, label: 'Dutch' },
{ id: 118, label: 'Norwegian Nynorsk' },
{ id: 119, label: 'Norwegian' },
{ id: 120, label: 'South Ndebele' },
{ id: 121, label: 'Navajo' },
{ id: 122, label: 'Chichewa; Chewa; Nyanja' },
{ id: 123, label: 'Occitan' },
{ id: 124, label: 'Ojibwe' },
{ id: 125, label: 'Oromo' },
{ id: 126, label: 'Oriya' },
{ id: 127, label: 'Ossetian' },
{ id: 128, label: 'Panjabi' },
{ id: 129, label: 'Pāli' },
{ id: 130, label: 'Polish' },
{ id: 131, label: 'Pashto' },
{ id: 132, label: 'Portuguese' },
{ id: 133, label: 'Quechua' },
{ id: 134, label: 'Romansh' },
{ id: 135, label: 'Kirundi' },
{ id: 136, label: 'Romanian' },
{ id: 137, label: 'Russian' },
{ id: 138, label: 'Kinyarwanda' },
{ id: 139, label: 'Sanskrit (Saṁskṛta)' },
{ id: 140, label: 'Sardinian' },
{ id: 141, label: 'Sindhi' },
{ id: 142, label: 'Northern Sami' },
{ id: 143, label: 'Sango' },
{ id: 144, label: 'Sinhala' },
{ id: 145, label: 'Slovak' },
{ id: 146, label: 'Slovene' },
{ id: 147, label: 'Samoan' },
{ id: 148, label: 'Shona' },
{ id: 149, label: 'Somali' },
{ id: 150, label: 'Albanian' },
{ id: 151, label: 'Serbian' },
{ id: 152, label: 'Swati' },
{ id: 153, label: 'Southern Sotho' },
{ id: 154, label: 'Sundanese' },
{ id: 155, label: 'Swedish' },
{ id: 156, label: 'Swahili' },
{ id: 157, label: 'Tamil' },
{ id: 158, label: 'Telugu' },
{ id: 159, label: 'Tajik' },
{ id: 160, label: 'Thai' },
{ id: 161, label: 'Tigrinya' },
{ id: 162, label: 'Turkmen' },
{ id: 163, label: 'Tagalog' },
{ id: 164, label: 'Tswana' },
{ id: 165, label: 'Tonga (Tonga Islands)' },
{ id: 166, label: 'Turkish' },
{ id: 167, label: 'Tsonga' },
{ id: 168, label: 'Tatar' },
{ id: 169, label: 'Twi' },
{ id: 170, label: 'Tahitian' },
{ id: 171, label: 'Uyghur' },
{ id: 172, label: 'Ukrainian' },
{ id: 173, label: 'Urdu' },
{ id: 174, label: 'Uzbek' },
{ id: 175, label: 'Venda' },
{ id: 176, label: 'Vietnamese' },
{ id: 177, label: 'Volapük' },
{ id: 178, label: 'Walloon' },
{ id: 179, label: 'Wolof' },
{ id: 180, label: 'Xhosa' },
{ id: 181, label: 'Yiddish' },
{ id: 182, label: 'Yoruba' },
{ id: 183, label: 'Zhuang' },
{ id: 184, label: 'Chinese' },
{ id: 185, label: 'Zulu' }
];
